export default __webpack_public_path__ + "static/media/pyme.daecf825.webp";